document.addEventListener('DOMContentLoaded', function () {
  // 1. Get store name from the page heading
  const storeHeadingEl = document.querySelector(
    '.location-header .section-content__heading.h1'
  );
  if (!storeHeadingEl) return;

  const storeName = storeHeadingEl.textContent.trim();
  if (!storeName) return;

  // 2. Find the Extended Hours container
  const extendedWrapper = document.querySelector(
    '.contact-info__trading.extended-hours.contact-info.no-border'
  );
  if (!extendedWrapper) return;

  const labelEl = extendedWrapper.querySelector('.contact-label');
  if (!labelEl) return;

  // 3. Get CSV URL injected via Liquid
  const csvUrl = window.extendedHoursCsvUrl;
  if (!csvUrl) return;

  // ---------- Helpers ----------

  function parseCsv(text) {
    const lines = text.split(/\r?\n/).filter(line => line.trim() !== '');
    if (!lines.length) return [];

    const headers = lines[0]
      .split(',')
      .map(h => h.replace(/^\uFEFF/, '').trim());

    const rows = [];

    for (let i = 1; i < lines.length; i++) {
      const cols = lines[i].split(',');
      if (!cols.length) continue;

      const row = {};
      headers.forEach((h, idx) => {
        row[h] = (cols[idx] || '').trim();
      });
      rows.push(row);
    }

    return rows;
  }

  function normalizeStoreName(str) {
    return (str || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');
  }

  function ordinal(n) {
    const v = n % 100;
    if (v >= 11 && v <= 13) return n + 'th';
    const last = n % 10;
    if (last === 1) return n + 'st';
    if (last === 2) return n + 'nd';
    if (last === 3) return n + 'rd';
    return n + 'th';
  }

  // Convert header like "18-Dec-25" or "1-Jan-26" -> "18th December 2025"
  function formatDateHeader(header) {
    if (!header) return '';

    const clean = header.trim().split(' ')[0];

    const monthsMap = {
      Jan: 'January',
      Feb: 'February',
      Mar: 'March',
      Apr: 'April',
      May: 'May',
      Jun: 'June',
      Jul: 'July',
      Aug: 'August',
      Sep: 'September',
      Oct: 'October',
      Nov: 'November',
      Dec: 'December'
    };

    let m = clean.match(/^(\d{1,2})-([A-Za-z]{3})-(\d{2}|\d{4})$/);
    if (m) {
      const dayNum = parseInt(m[1], 10);
      const monthAbbr = m[2];
      const yearPart = parseInt(m[3], 10);

      const monthName = monthsMap[monthAbbr] || monthAbbr;
      const yearFull =
        m[3].length === 2
          ? yearPart <= 49
            ? 2000 + yearPart
            : 1900 + yearPart
          : yearPart;

      return `${ordinal(dayNum)} ${monthName} ${yearFull}`;
    }

    m = clean.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (m) {
      const year = parseInt(m[1], 10);
      const monthIndex = parseInt(m[2], 10) - 1;
      const dayNum = parseInt(m[3], 10);

      const dateObj = new Date(year, monthIndex, dayNum);
      const monthName = dateObj.toLocaleString('en-AU', { month: 'long' });

      return `${ordinal(dayNum)} ${monthName} ${year}`;
    }

    return header;
  }

  // ---------- Fetch CSV and render extended hours ----------

  fetch(csvUrl)
    .then(response => {
      if (!response.ok) {
        throw new Error('Failed to load CSV: ' + response.status);
      }
      return response.text();
    })
    .then(text => {
      const rows = parseCsv(text);
      if (!rows.length) return;

      // Find the actual Store column regardless of case/BOM issues
      const firstRow = rows[0];
      const storeKey = Object.keys(firstRow).find(key => {
        return key.trim().toLowerCase() === 'store';
      });

      if (!storeKey) {
        console.log('No Store column found in CSV');
        return;
      }

      const normalizedStoreName = normalizeStoreName(storeName);

      // Match exact normalized store name first
      let row = rows.find(r => {
        const csvStore = normalizeStoreName(r[storeKey]);
        return csvStore === normalizedStoreName;
      });

      // Fallback partial match if needed
      if (!row) {
        row = rows.find(r => {
          const csvStore = normalizeStoreName(r[storeKey]);
          return (
            csvStore === normalizedStoreName ||
            normalizedStoreName.includes(csvStore) ||
            csvStore.includes(normalizedStoreName)
          );
        });
      }

      if (!row) {
        console.log('No matching store found for:', storeName);
        extendedWrapper.style.display = 'none';
        return;
      }

      const entries = [];

      Object.keys(row).forEach(key => {
        if (key === storeKey) return;

        const raw = row[key];
        if (!raw) return;

        const val = raw.trim();
        if (!val) return;

        // Skip unwanted values only
        const lower = val.toLowerCase();
        if (lower === 'normal' || lower === 'centre') return;

        // Normalise AM/PM
        const hours = val.replace(/AM/g, 'am').replace(/PM/g, 'pm');

        const dateStr = formatDateHeader(key);
        entries.push({ date: dateStr, hours });
      });

      if (!entries.length) {
        extendedWrapper.style.display = 'none';
        return;
      }

      // Remove old rendered entries if script runs more than once
      const existingLines = extendedWrapper.querySelector('.extended-hours__lines');
      if (existingLines) {
        existingLines.remove();
      }

      const linesContainer = document.createElement('div');
      linesContainer.className = 'extended-hours__lines';

      entries.forEach(entry => {
        const line = document.createElement('div');
        line.className = 'extended-hours__line';
        line.textContent = `${entry.date}: ${entry.hours}`;
        linesContainer.appendChild(line);
      });

      labelEl.insertAdjacentElement('afterend', linesContainer);
    })
    .catch(err => {
      console.error('Error loading extended hours CSV', err);
    });
});